module.exports = __webpack_public_path__ + "img/circle2blue.c3a780fa.png";